<script>
  import ClipboardCopy from "../ClipboardCopy.svelte"
  import SearchParams from "./utils/search_params.js"

  export let attributes
  export let mode
  export let text

  const label = "Share this screen"
  const successText = "A link to this screen was copied to your clipboard!"
  const timeOut = 2500

  const searchParams = new SearchParams()
  $: value = generateUrl(mode, text, attributes)

  function generateUrl(mode, text, attributes) {
    searchParams.mode = mode
    searchParams.text = text
    searchParams.attributes = attributes
    return `${window.location.origin}${window.location.pathname}#?${searchParams.params}`
  }
</script>

<div>
  <ClipboardCopy {label} {value} {successText} {timeOut} />
</div>

<style>
  div {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
    color: var(--black);
  }
</style>
